import dynamic from "next/dynamic";

export const DynamicContent010 = dynamic(() => import("./Content010"), {
  suspense: true,
});
